import React from "react";

const team = [
  {
    name: "Jakub Chudecki",
    role: "Lead Physiotherapist",
    creds: "MSc Physiotherapy · HCPC & CSP registered",
    bio: "Lead physiotherapist at Reading Physio Limited with over 25 years of clinical experience supporting injury recovery, falls prevention and healthy ageing.",
    img: "https://customer-assets.emergentagent.com/job_senior-balance-rehab/artifacts/egxvwbig_WhatsApp%20Image%202026-06-27%20at%2012.31.15.jpeg",
  },
  {
    name: "Sylwia Chudecki",
    role: "Assistant Physiotherapist & Massage Therapist",
    creds: "BSc (Hons) Nursing · CSP & FHT registered · MSc Physiotherapy student",
    bio: "Registered massage therapist and assistant physiotherapist, currently completing an MSc in Physiotherapy. Brings a nursing background and a calm, patient-centred approach to every session.",
    img: "https://customer-assets.emergentagent.com/job_senior-balance-rehab/artifacts/uoe424cy_WhatsApp%20Image%202026-06-27%20at%2012.47.36.jpeg",
  },
];

export default function Team() {
  return (
    <section
      id="team"
      className="py-20 md:py-32 px-6 md:px-12 bg-brand-clay/40"
      data-testid="team-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta" data-testid="team-eyebrow">
              The team
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-brand-blue mt-4 leading-tight" data-testid="team-headline">
              Hands you can trust. Faces you&apos;ll recognise.
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-slate-700 leading-relaxed">
            Our team is fully registered with the HCPC, the Chartered Society of Physiotherapy and the FHT —
            chosen for their warmth as much as their clinical skill.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {team.map((m, idx) => (
            <article
              key={m.name}
              className="bg-white rounded-3xl overflow-hidden border border-brand-clay hover:shadow-xl transition-shadow duration-300"
              data-testid={`team-card-${idx + 1}`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={m.img}
                  alt={`${m.name}, ${m.role}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <h3 className="font-display text-2xl md:text-3xl text-brand-blue">{m.name}</h3>
                <p className="text-sm font-semibold tracking-wide uppercase text-brand-terracotta mt-1">{m.role}</p>
                <p className="text-sm font-medium text-brand-teal mt-2">{m.creds}</p>
                <p className="text-base text-slate-600 mt-4 leading-relaxed">{m.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
